<script lang="ts">
  import type { MyFitnessStores } from '@/MyFitness/stores';
  import type { ForecastActivityState } from './constants';
  import { Activity, type Exercise } from './ActivityFunctions';
  import ForecastDescription from './ForecastDescription.svelte';
  import { cn } from '@/lib/utils';

  // The expandable section under a forecast activity: an explanation of Magic Buckets for an XMB activity, the workout's
  // description when one is assigned, or else the Training Explanation of the forecast day.
  export let activity: Exercise;
  export let forecastInfo: ForecastActivityState | undefined;
  export let myFitness: MyFitnessStores;
  export let className: string = '';

  const { trainingPlan } = myFitness;

  $: workoutPath = Activity.getWorkoutPath(activity);
  $: isMagicBuckets = Activity.isMagicBuckets(activity);
  // An assigned workout's description is copied to the activity when it is scheduled.
  $: description = !isMagicBuckets && workoutPath && String(workoutPath) !== '0' ? activity.description?.trim() : '';
</script>

{#if forecastInfo}
  <details class={cn('mt-2', className)}>
    <summary class="list-item cursor-pointer text-sm text-primary hover:underline">
      {isMagicBuckets ? 'Explanation' : description ? 'Description' : 'Training Explanation'}
    </summary>
    <div class='mt-2'>
      {#if isMagicBuckets}
        Xert Magic Buckets (XMB) is a training feature available on Xert EBC for iOS, Android and Hammerhead Karoo as well as
        a Connect IQ datafield on your Garmin. It allows you to achieve your training targets without following a pre-defined
        workout. <a href="https://www.baronbiosys.com/magic-buckets/" target="_help">Learn More</a>.
      {:else if description}
        <p class="m-0 whitespace-pre-line">{description}</p>
      {:else}
        <ForecastDescription {myFitness} selectedMode={$trainingPlan?.selected_mode} {forecastInfo} />
      {/if}
    </div>
  </details>
{/if}
